<div class="std-ta-center">
  <div nxModalContent>
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">
      {{ type ?? "" }}
    </h3>
    <p nxCopytext="normal" class="nx-margin-bottom-m nx-font-weight-light">
      {{ message }}
    </p>
  </div>

  <button nxModalClose class="button_popup_2btn" nxButton="primary" type="button" (click)="onclickOK()">
    YES
  </button>
  <button nxModalClose nxButton="primary" type="button">
    NO
  </button>
</div>